import { FC, ReactNode } from 'react';
import styles from './basic.less';

interface BasicLayoutProps {
  children?: ReactNode;
  loading?: boolean;
}

const BasicLayout: FC<BasicLayoutProps> = ({ children, loading = false }) => {
  const renderLoading = () =>
    <div className={styles.loading}>
      <span className={styles.spin} />
    </div>

  return loading ? renderLoading() : (
    <div className={styles.basicLayout}>
      {children}
    </div>
  );
}

export default BasicLayout;